import { PROVINCES } from '@/constants';

const COMMISSION_ON_FIRST_100_K = 'Commission on first 100k';

export const COMMISSION_SLIDER_TITLE = {
  [PROVINCES.AB]: COMMISSION_ON_FIRST_100_K,
  [PROVINCES.BC]: COMMISSION_ON_FIRST_100_K,
  [PROVINCES.ON]: 'Buyer agent commission based on total price of home',
};

export default {
  COMMISSION_SLIDER_TITLE,
};
